import { useState, useEffect } from 'react';

const TIMEOUT = process.env.FLASH_TIMEOUT || 5000;

const useVisible = (defaultState = true) => {
    const [visible, setVisible] = useState(defaultState);
    useEffect(() => {
        if (visible) {
            const timer = setTimeout(() => setVisible(false), TIMEOUT);
            return () => clearTimeout(timer);
        }
    }, [visible]);
    const open = () => setVisible(true);
    return { visible, open };
}

export default useVisible;